import axios from 'axios'
import { toData } from './util'

export function searchLicenses(query, subsidiaryId): Promise {
  return axios.get('/api/licenses/search', { params: { query: query, subsidiaryId: subsidiaryId } }).then(toData)
}

export function searchLicensesByActivationCode(query, subsidiaryId): Promise {
  return axios.get('/api/licenses/searchByActivationCode', { params: { query: query, subsidiaryId: subsidiaryId } }).then(toData)
}

export function searchLicensesByActivationCodeOrUserId(query, page): Promise {
  return axios.get('/api/licenses/searchByActivationCodeOrUserId', { params: { query: query, page: page } }).then(toData)
}

export function getLicense(param, subsidiaryId): Promise {
  return axios.get(`/api/licenses/${param}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function getLicenseGroupOptions(param, subsidiaryId): Promise {
  return axios.get(`/api/licenses/${param}/group-options?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function sendActivationCode(id, subsidiaryId, email): Promise {
  return axios
    .post(`/api/licenses/resend-activation-code/${id}?subsidiaryId=${subsidiaryId}&email=${email}`)
    .then(toData)
}

export function rollback(id, subsidiaryId): Promise {
  return axios.post(`/api/licenses/rollback/${id}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function update(license, subsidiaryId): Promise {
  return axios.put(`/api/licenses/${license.id}?subsidiaryId=${subsidiaryId}`, license).then(toData)
}
